import { AutocompleteInput, Filter, ReferenceInput } from "react-admin";


export const ReportFilter = (props: any) =>
    <Filter {...props}>
        <ReferenceInput label="Reporter" source="reporter" reference="user" allowEmpty alwaysOn >
            <AutocompleteInput optionText="profile.nickname" filterToQuery={txt => ({ profile: { nickname: txt } })}
                size='small'
            />
        </ReferenceInput>
        <ReferenceInput label="About" source="about" reference="user" allowEmpty alwaysOn >
            <AutocompleteInput optionText="profile.nickname" filterToQuery={txt => ({ profile: { nickname: txt } })}
                size='small'
            />
        </ReferenceInput>
    </Filter>